export default __webpack_public_path__ + "static/media/HIV-icon.918fefbc.png";